function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 0h40c4.4 0 8 3.6 8 8l8 36v20c0 4.4-3.6 8-8 8H8c-4.44 0-8-3.6-8-8V44L8 8c0-4.4 3.6-8 8-8zm36 44h12L56 8H16L8 44h12c2.21 0 3.94 1.823 4.528 3.952C25.612 51.882 28.638 56 36 56c7.362 0 10.388-4.119 11.472-8.048C48.06 45.822 49.791 44 52 44z",
  fill: "#CFD7DE"
});

var SvgInbox = function SvgInbox(props) {
  return React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/inbox.8aa5c402.svg";
export { SvgInbox as ReactComponent };